import { render } from "./Incidences.vue?vue&type=template&id=93990200&scoped=true"
import script from "./Incidences.vue?vue&type=script&lang=js"
export * from "./Incidences.vue?vue&type=script&lang=js"

import "./Incidences.vue?vue&type=style&index=0&id=93990200&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93990200"]])

export default __exports__